import { configureStore } from '@reduxjs/toolkit'

import setProduct from './reducers/productSlice'
import setTheme from './reducers/themeSlice'
import setDevice from './reducers/deviceSlice'

export const store = configureStore({
  reducer: {
    product: setProduct,
    theme: setTheme,
    device: setDevice,
  },
})
